/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { JobConfigurationDtoTargetSystem } from './JobConfigurationDtoTargetSystem';
import {
    JobConfigurationDtoTargetSystemFromJSON,
    JobConfigurationDtoTargetSystemFromJSONTyped,
    JobConfigurationDtoTargetSystemToJSON,
} from './JobConfigurationDtoTargetSystem';
import type { JobScheduleDto } from './JobScheduleDto';
import {
    JobScheduleDtoFromJSON,
    JobScheduleDtoFromJSONTyped,
    JobScheduleDtoToJSON,
} from './JobScheduleDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RoleCatalogDto } from './RoleCatalogDto';
import {
    RoleCatalogDtoFromJSON,
    RoleCatalogDtoFromJSONTyped,
    RoleCatalogDtoToJSON,
} from './RoleCatalogDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface JobConfigurationDto
 */
export interface JobConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof JobConfigurationDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof JobConfigurationDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof JobConfigurationDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof JobConfigurationDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof JobConfigurationDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof JobConfigurationDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof JobConfigurationDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobConfigurationDto
     */
    assignedUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobConfigurationDto
     */
    assignedRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobConfigurationDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    reviewUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    reviewRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobConfigurationDto
     */
    reviewUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobConfigurationDto
     */
    reviewRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobConfigurationDto
     */
    reviewRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {JobConfigurationDtoTargetSystem}
     * @memberof JobConfigurationDto
     */
    targetSystem?: JobConfigurationDtoTargetSystem | null;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof JobConfigurationDto
     */
    tasks?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    activeTaskInJobCount?: number;
    /**
     * 
     * @type {JobScheduleDto}
     * @memberof JobConfigurationDto
     */
    schedule?: JobScheduleDto;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    $type?: JobConfigurationDtoTypeEnum;
}


/**
 * @export
 */
export const JobConfigurationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoJobConfigurationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.JobConfigurationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobConfigurationDtoTypeEnum = typeof JobConfigurationDtoTypeEnum[keyof typeof JobConfigurationDtoTypeEnum];


/**
 * Check if a given object implements the JobConfigurationDto interface.
 */
export function instanceOfJobConfigurationDto(value?: unknown): value is JobConfigurationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobConfigurationDtoTypeEnum)[0];
}

export function JobConfigurationDtoFromJSON(json: any): JobConfigurationDto {
    return JobConfigurationDtoFromJSONTyped(json, false);
}

export function JobConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobConfigurationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'protocols': !exists(json, 'protocols') ? undefined : (json['protocols'] === null ? null : (json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        'assignedUserIds': !exists(json, 'assignedUserIds') ? undefined : json['assignedUserIds'],
        'assignedRoleIds': !exists(json, 'assignedRoleIds') ? undefined : json['assignedRoleIds'],
        'assignedUsers': !exists(json, 'assignedUsers') ? undefined : (json['assignedUsers'] === null ? null : (json['assignedUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'assignedRoles': !exists(json, 'assignedRoles') ? undefined : (json['assignedRoles'] === null ? null : (json['assignedRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'assignedRolesDisplayNames': !exists(json, 'assignedRolesDisplayNames') ? undefined : json['assignedRolesDisplayNames'],
        'reviewRequired': !exists(json, 'reviewRequired') ? undefined : json['reviewRequired'],
        'reviewUserIds': !exists(json, 'reviewUserIds') ? undefined : json['reviewUserIds'],
        'reviewRoleIds': !exists(json, 'reviewRoleIds') ? undefined : json['reviewRoleIds'],
        'reviewUsers': !exists(json, 'reviewUsers') ? undefined : (json['reviewUsers'] === null ? null : (json['reviewUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'reviewRoles': !exists(json, 'reviewRoles') ? undefined : (json['reviewRoles'] === null ? null : (json['reviewRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'reviewRolesDisplayNames': !exists(json, 'reviewRolesDisplayNames') ? undefined : json['reviewRolesDisplayNames'],
        'autoApprove': !exists(json, 'autoApprove') ? undefined : json['autoApprove'],
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'targetSystem': !exists(json, 'targetSystem') ? undefined : JobConfigurationDtoTargetSystemFromJSON(json['targetSystem']),
        'tasks': !exists(json, 'tasks') ? undefined : (json['tasks'] === null ? null : (json['tasks'] as Array<any>).map(TaskInJobDtoFromJSON)),
        'activeTaskInJobCount': !exists(json, 'activeTaskInJobCount') ? undefined : json['activeTaskInJobCount'],
        'schedule': !exists(json, 'schedule') ? undefined : JobScheduleDtoFromJSON(json['schedule']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function JobConfigurationDtoToJSON(value?: JobConfigurationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value.state),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'protocols': value.protocols === undefined ? undefined : (value.protocols === null ? null : (value.protocols as Array<any>).map(ProtocolDtoToJSON)),
        'assignedUserIds': value.assignedUserIds,
        'assignedRoleIds': value.assignedRoleIds,
        'assignedUsers': value.assignedUsers === undefined ? undefined : (value.assignedUsers === null ? null : (value.assignedUsers as Array<any>).map(UserCatalogDtoToJSON)),
        'assignedRoles': value.assignedRoles === undefined ? undefined : (value.assignedRoles === null ? null : (value.assignedRoles as Array<any>).map(RoleCatalogDtoToJSON)),
        'assignedRolesDisplayNames': value.assignedRolesDisplayNames,
        'reviewRequired': value.reviewRequired,
        'reviewUserIds': value.reviewUserIds,
        'reviewRoleIds': value.reviewRoleIds,
        'reviewUsers': value.reviewUsers === undefined ? undefined : (value.reviewUsers === null ? null : (value.reviewUsers as Array<any>).map(UserCatalogDtoToJSON)),
        'reviewRoles': value.reviewRoles === undefined ? undefined : (value.reviewRoles === null ? null : (value.reviewRoles as Array<any>).map(RoleCatalogDtoToJSON)),
        'reviewRolesDisplayNames': value.reviewRolesDisplayNames,
        'autoApprove': value.autoApprove,
        'targetSystemId': value.targetSystemId,
        'targetSystem': JobConfigurationDtoTargetSystemToJSON(value.targetSystem),
        'tasks': value.tasks === undefined ? undefined : (value.tasks === null ? null : (value.tasks as Array<any>).map(TaskInJobDtoToJSON)),
        'activeTaskInJobCount': value.activeTaskInJobCount,
        'schedule': JobScheduleDtoToJSON(value.schedule),
        '$type': value.$type,
    });
}

